import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getAuthConfig = () => {
  try {
    const userinfo = localStorage.getItem("user");
    const userData = userinfo ? JSON.parse(userinfo) : null;
    const token = userData?.token;
    return {
      headers: {
        Authorization: `Bearer ${token || ""}`,
        Accept: "application/json",
      },
    };
  } catch (e) {
    return {};
  }
};

const getUsers = async () => {
  const response = await axios.get(`${base_url}user/all-users`, getAuthConfig());
  return response.data;
};

const getaUser = async (id) => {
  const response = await axios.get(`${base_url}user/${id}`, getAuthConfig());
  return response.data;
};

const createUser = async (classes) => {
  const response = await axios.post(
    `${base_url}user/register`,
    classes,
    getAuthConfig()
  );
  return response.data;
};

const updateUser = async (user) => {
  const response = await axios.put(`${base_url}user/edit-user`, user, getAuthConfig());
  return response.data;
};

const deleteUser = async (id) => {
  const response = await axios.delete(`${base_url}user/${id}`, getAuthConfig());
  return response.data;
};

const blockCustomer = async (customerId, isBlocked) => {
  const url = isBlocked
    ? `${base_url}user/unblock-user/${customerId}`
    : `${base_url}user/block-user/${customerId}`;
  const response = await axios.put(url, {}, getAuthConfig());
  return response.data;
};

const customerService = {
  getUsers,
  getaUser,
  createUser,
  updateUser,
  deleteUser,
  blockCustomer,
};

export default customerService;
